import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchUsers } from "../../services/adminApi";
import moment from "moment";


// Dummy user data (later API se aa jayega)
// const dummyUsers = [
//   {
//     id: 1,
//     name: "Sanjay Parmar",
//     email: "sanjay@gmail.com",
//     salary: "₹45,000",
//     expense: "₹18,200",
//     joinDate: "12 Jan 2024",
//   },
//   {
//     id: 2,
//     name: "Rahul Sharma",
//     email: "rahul@gmail.com",
//     salary: "₹38,000",
//     expense: "₹14,500",
//     joinDate: "03 Feb 2024",
//   },
//   {
//     id: 3,
//     name: "Neha Verma",
//     email: "neha@gmail.com",
//     salary: "₹50,000",
//     expense: "₹22,100",
//     joinDate: "20 Mar 2024",
//   },
// ];

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const logout = () => {
    localStorage.removeItem("admin_logged_in");
    // localStorage.removeItem("admin_token");
    navigate("/BudgetmateAdmin");
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      const res = await fetchUsers();
      if (res.success) {
      setUsers(res.data);
      }
    } catch (err) {
      console.error("Failed to load users", err);
      //   alert("Unable to load users");
    } finally {
      setLoading(false);
    }
  };

  console.log("value----",users)
  return (
    <div style={styles.wrapper}>
      {/* ================= Sidebar ================= */}
      <div style={{ ...styles.sidebar, width: menuOpen ? 220 : 70 }}>
        <div style={styles.hamburger} onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </div>

        <div style={styles.menuItem}>
          📊 {menuOpen && <span>Dashboard</span>}
        </div>

        {menuOpen && (
          <>
            <div style={styles.menuItem}>👤 Users</div>
            <div style={styles.menuItem}>📁 Reports</div>
            {/* <div style={styles.menuItem}>⚙ Settings</div> */}
               <div
              style={styles.menuItem}
              onClick={() => navigate("/BudgetmateAdmin/settings")}
            >
              ⚙ Settings
            </div>
          </>
        )}
      </div>

      {/* ================= Main Content ================= */}
      <div style={styles.content}>
        {/* Header */}
        <div style={styles.header}>
          <h2 style={{ margin: 0 }}>Admin Dashboard</h2>
          <button style={styles.logoutBtn} onClick={logout}>
            Logout
          </button>
        </div>

        {/* User Table */}
        <div style={styles.card}>
          <h3 style={{ marginBottom: 16 }}>User List</h3>

          {loading ? (
            <p>Loading users...</p>
          ) : (
                       
            <table style={styles.table}>
              <thead>
                <tr>
                  <th>S No.</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Salary</th>
                  <th>Total Expense</th>
                  <th>Join Date</th>
                </tr>
              </thead>

              <tbody>
                {users?.length > 0 &&users.map((user,index) => {
                console.log("------",user)
                  return(
                    <tr key={user._id}>
                    <td>{index + 1}</td>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.salary}</td>
                    <td>{user.salary}</td>
                    <td>{moment(user.createdAt).format("DD MMM YYYY")}</td>
                  </tr>
                  )
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

/* ================= Styles ================= */

const styles = {
  wrapper: {
    display: "flex",
    minHeight: "100vh",
    background: "#f4f6f8",
    fontFamily: "Arial, sans-serif",
  },

  sidebar: {
    background: "#111827",
    color: "#fff",
    transition: "0.3s",
    paddingTop: 16,
  },

  hamburger: {
    fontSize: 22,
    padding: "12px 20px",
    cursor: "pointer",
  },

  menuItem: {
    padding: "12px 20px",
    cursor: "pointer",
    whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center",
    gap: 10,
  },

  content: {
    flex: 1,
    padding: 24,
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },

  logoutBtn: {
    background: "#ef4444",
    border: "none",
    color: "#fff",
    padding: "8px 14px",
    borderRadius: 6,
    cursor: "pointer",
  },

  card: {
    background: "#fff",
    padding: 20,
    borderRadius: 12,
    boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
};

/* Table styles */
const styleSheet = document.createElement("style");
styleSheet.innerHTML = `
  table th, table td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #eee;
  }
  table th {
    background: #f9fafb;
    font-weight: 600;
  }
  table tr:hover {
    background: #f3f4f6;
  }
`;
document.head.appendChild(styleSheet);
